import { api } from "@/lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { conversionsKeys } from "./conversions.queries";
import { useRouter } from "@tanstack/react-router";
import { StudentInformationInput } from "@/types/dashboard.types";

interface ManualConversionProps {
  countryId: string;
  gradingScaleId: string;
  data: Array<{
    id: number;
    course: string;
    credits: string;
    grade: string;
  }>;
  studentInformation: StudentInformationInput;
  pdfFile: File | null;
}
export const useManualConversion = () => {
  const queryClient = useQueryClient();
  const router = useRouter();
  return useMutation({
    mutationFn: async ({
      countryId,
      gradingScaleId,
      data,
      studentInformation,
      pdfFile,
    }: ManualConversionProps) => {
      if (!pdfFile) {
        throw new Error("File attachment missing");
      }

      const formData = new FormData();
      formData.append("countryId", countryId);
      formData.append("gradingScaleId", gradingScaleId);
      formData.append("data", JSON.stringify(data));
      formData.append("studentInformation", JSON.stringify(studentInformation));
      formData.append("pdfFile", pdfFile);

      const response = await api.post<string>(
        "/api/conversion/manual",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      router.navigate({
        to: "/dashboard/conversion-history/$id",
        params: {
          id: response.data,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: conversionsKeys.all });
    },
  });
};
